import { PackageSize } from 'src/common/types';

export const getTotalBags = (packageSizes: PackageSize[]): number => {
  return packageSizes.reduce((acc, curr) => acc + curr.quantity, 0);
};
